<template>
  <b-container fluid>
    <div>
      <h3>Waldo</h3>
      <p>The World's First Heuristic Name Risk Assessment Algorithm</p>
    </div>
    <b-row class="mt-4">
      <!-- colum one -->
      <b-col cols="4" style="height:calc(100vh - 150px); overflow-y: auto;">
        <div>
          <p>Step : 1 Client Input Sheet</p>
        </div>
        <b-table-simple small bordered>
          <b-thead>
            <b-tr>
              <b-th>Input</b-th>
              <b-th>Data</b-th>
            </b-tr>
          </b-thead>
          <b-tbody>
            <b-tr>
              <b-th>First Name</b-th>
              <b-td>
                <b-form-input
                  placeholder="Enter First Name"
                  :disabled="disableFirstName"
                  @keyup.enter="addFirstName()"
                  v-model="firstName"
                ></b-form-input>
              </b-td>
            </b-tr>
            <b-tr>
              <b-th>Middle Name</b-th>
              <b-td>
                <b-form-input
                  placeholder="Enter Middle Name"
                  :disabled="disableMiddleName"
                  @keyup.enter="addMiddleName()"
                  v-model="middleName"
                ></b-form-input>
              </b-td>
            </b-tr>
            <b-tr>
              <b-th>Last Name</b-th>
              <b-td>
                <b-form-input
                  placeholder="Enter Last Name"
                  :disabled="disableLastName"
                  @keyup.enter="addLastName()"
                  v-model="lastName"
                ></b-form-input>
              </b-td>
            </b-tr>
            <b-tr>
              <b-td>Full Name</b-td>
              <b-td>{{firstName}} {{middleName}} {{lastName}}</b-td>
            </b-tr>
            <b-tr>
              <b-td>&nbsp; &nbsp;</b-td>
              <b-td>&nbsp; &nbsp;</b-td>
            </b-tr>
            <b-tr>
              <b-th>Date of Birth</b-th>
              <b-td>
                <Datepicker
                  input-class="custom-date-picker"
                  calendar-class="date-calender"
                  class="form-control"
                  v-model="dateOfBirth"
                  :format="formatDate"
                ></Datepicker>
              </b-td>
            </b-tr>
            <b-tr>
              <b-td>Year of Birth</b-td>
              <b-td>{{formatYear(dateOfBirth)}}</b-td>
            </b-tr>
            <b-tr>
              <b-td>Current Age</b-td>
              <b-td>{{getAgeFromBirthday(dateOfBirth)}} Years</b-td>
            </b-tr>
            <b-tr>
              <b-td>&nbsp; &nbsp;</b-td>
              <b-td>&nbsp; &nbsp;</b-td>
            </b-tr>
            <b-tr>
              <b-th>Country</b-th>
              <b-td>United Kingdom</b-td>
            </b-tr>
            <b-tr style="background-color: black;">
              <b-td>&nbsp; &nbsp;</b-td>
              <b-td>&nbsp; &nbsp;</b-td>
            </b-tr>
            <b-tr>
              <b-th>City</b-th>
              <b-td>Dumfries</b-td>
            </b-tr>
            <b-tr>
              <b-td>&nbsp; &nbsp;</b-td>
              <b-td>&nbsp; &nbsp;</b-td>
            </b-tr>
          </b-tbody>
        </b-table-simple>
      </b-col>

      <b-col cols="4" style="height:calc(100vh - 150px); overflow-y: auto;">
        <p>Step : 2 LinkedIn Matches (Country Specific)</p>
        <b-table-simple small bordered>
          <b-thead>
            <b-tr>
              <b-th>Type</b-th>
              <b-th>Value</b-th>
            </b-tr>
          </b-thead>
          <b-tbody>
            <b-tr>
              <b-td>Exact</b-td>
              <b-td>
                <b-form-input type="number"></b-form-input>
              </b-td>
            </b-tr>
            <b-tr>
              <b-td>Exact + Partial</b-td>
              <b-td>
                <b-form-input type="number"></b-form-input>
              </b-td>
            </b-tr>
          </b-tbody>
        </b-table-simple>

        <p>LinkedIn Matches (World)</p>
        <b-table-simple small bordered>
          <b-thead>
            <b-tr>
              <b-th>Type</b-th>
              <b-th>Value</b-th>
            </b-tr>
          </b-thead>
          <b-tbody>
            <b-tr>
              <b-td>Exact</b-td>
              <b-td>
                <b-form-input type="number"></b-form-input>
              </b-td>
            </b-tr>
            <b-tr>
              <b-td>Exact + Partial</b-td>
              <b-td>
                <b-form-input type="number"></b-form-input>
              </b-td>
            </b-tr>
          </b-tbody>
        </b-table-simple>

        <p>Base Probability of {{firstName}} {{middleName}} {{lastName}} in the World</p>
        <b-table small :items="BaseProbabilityWorldItems" :fields="BaseProbabilityFields" bordered></b-table>

        <p>Base Probability of {{firstName}} {{middleName}} {{lastName}} in United Kingdom</p>
        <b-table
          small
          :items="BaseProbabilityUnitedKingdomItems"
          :fields="BaseProbabilityFields"
          bordered
        ></b-table>

        <p>Base Probability of {{firstName}} {{middleName}} {{lastName}} in Dumfries, United Kingdom</p>
        <b-table
          small
          :items="BaseProbabilityDumfriesItems"
          :fields="BaseProbabilityFields"
          bordered
        ></b-table>
      </b-col>
      <b-col cols="4" style="height:calc(100vh - 150px); overflow-y: auto;">
        <p>Step : 3 Alert Checker</p>
        <b-table-simple small bordered>
          <b-thead>
            <b-tr>
              <b-th>Type</b-th>
              <b-th>Match</b-th>
            </b-tr>
          </b-thead>
          <b-tbody>
            <b-tr>
              <b-th>Alert Match Type</b-th>
              <b-td>
                <b-form-group stacked class="text-left">
                  <b-form-radio v-model="selectedAlert" value="1">Exact</b-form-radio>
                  <b-form-radio v-model="selectedAlert" value="2">Partial</b-form-radio>
                </b-form-group>
              </b-td>
            </b-tr>
            <b-tr>
              <b-td>&nbsp; &nbsp;</b-td>
              <b-td>&nbsp; &nbsp;</b-td>
            </b-tr>
            <b-tr>
              <b-th>Year of Birth</b-th>
              <b-td>
                <b-form-group stacked class="text-left">
                  <b-form-radio v-model="selectedYear" value="1">No Data</b-form-radio>
                  <b-form-radio v-model="selectedYear" value="2">Yes</b-form-radio>
                  <b-form-radio v-model="selectedYear" value="3">No</b-form-radio>
                </b-form-group>
              </b-td>
            </b-tr>
            <b-tr>
              <b-th>Date of Birth Match</b-th>
              <b-td>
                <b-form-group stacked class="text-left">
                  <b-form-radio v-model="selectedDate" value="1">No Data</b-form-radio>
                  <b-form-radio v-model="selectedDate" value="2">Yes</b-form-radio>
                  <b-form-radio v-model="selectedDate" value="3">No</b-form-radio>
                </b-form-group>
              </b-td>
            </b-tr>
            <b-tr>
              <b-td>&nbsp; &nbsp;</b-td>
              <b-td>&nbsp; &nbsp;</b-td>
            </b-tr>
            <b-tr>
              <b-th>Country Match</b-th>
              <b-td>
                <b-form-group stacked class="text-left">
                  <b-form-radio v-model="selectedCountry" value="1">No Data</b-form-radio>
                  <b-form-radio v-model="selectedCountry" value="2">Yes</b-form-radio>
                  <b-form-radio v-model="selectedCountry" value="3">No</b-form-radio>
                </b-form-group>
              </b-td>
            </b-tr>
            <b-tr style="background-color: black;">
              <b-td>&nbsp; &nbsp;</b-td>
              <b-td>&nbsp; &nbsp;</b-td>
            </b-tr>
            <b-tr>
              <b-th>Nature of Alert</b-th>
              <b-td>
                <b-form-group stacked class="text-left">
                  <b-form-radio v-model="selectedNature" value="1">No Data</b-form-radio>
                  <b-form-radio v-model="selectedNature" value="2">White Collar</b-form-radio>
                  <b-form-radio v-model="selectedNature" value="3">Other</b-form-radio>
                </b-form-group>
              </b-td>
            </b-tr>
            <b-tr>
              <b-th>City Match</b-th>
              <b-td>
                <b-form-group stacked class="text-left">
                  <b-form-radio v-model="selectedCity" value="1">No Data</b-form-radio>
                  <b-form-radio v-model="selectedCity" value="2">Yes</b-form-radio>
                  <b-form-radio v-model="selectedCity" value="3">No</b-form-radio>
                </b-form-group>
              </b-td>
            </b-tr>
            <b-tr>
              <b-td>&nbsp; &nbsp;</b-td>
              <b-td>&nbsp; &nbsp;</b-td>
            </b-tr>
            <b-tr>
              <b-td>&nbsp; &nbsp;</b-td>
              <b-td>&nbsp; &nbsp;</b-td>
            </b-tr>
          </b-tbody>
        </b-table-simple>

        <p>Final Probability</p>
        <b-table small :items="FinalProbabilityItems" :fields="FinalProbabilityField" bordered></b-table>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import moment from "moment";
import Datepicker from "vuejs-datepicker";
export default {
  name: "WaldoPage",
  components: {
    Datepicker
  },
  data() {
    return {
      firstName: null,
      middleName: null,
      lastName: null,
      dateOfBirth: null,
      disableFirstName: false,
      disableMiddleName: false,
      disableLastName: false,
      selectedAlert: 1,
      selectedYear: 2,
      selectedDate: 1,
      selectedCountry: 3,
      selectedNature: 3,
      selectedCity: 2,
      BaseProbabilityFields: [
        {
          key: "action",
          label: ""
        },
        {
          key: "score",
          label: "Score"
        },
        {
          key: "possibles",
          label: "Possibles"
        },
        {
          key: "risk_assigned",
          label: "Risk Assigned"
        }
      ],
      BaseProbabilityWorldItems: [
        {
          action: "Exact",
          score: "0.0%",
          possibles: "8986",
          risk_assigned: "Extremely improbable",
          _cellVariants: {
            risk_assigned: "success"
          }
        },
        {
          action: "Partial",
          score: "0.0%",
          possibles: "15915",
          risk_assigned: "Extremely improbable",
          _cellVariants: {
            risk_assigned: "success"
          }
        }
      ],
      BaseProbabilityUnitedKingdomItems: [
        {
          action: "Exact",
          score: "0.3%",
          possibles: "309.5",
          risk_assigned: "Improbable",
          _cellVariants: {
            risk_assigned: "warning"
          }
        },
        {
          action: "Partial",
          score: "0.1%",
          possibles: "971.5",
          risk_assigned: "Improbable",
          _cellVariants: {
            risk_assigned: "warning"
          }
        }
      ],
      BaseProbabilityDumfriesItems: [
        {
          action: "Exact",
          score: "643.9%",
          possibles: ">1",
          risk_assigned: "Probable",
          _cellVariants: {
            risk_assigned: "danger"
          }
        },
        {
          action: "Partial",
          score: "205.1%",
          possibles: "0.5",
          risk_assigned: "Probable",
          _cellVariants: {
            risk_assigned: "danger"
          }
        }
      ],
      FinalProbabilityField: [
        {
          key: "action",
          label: ""
        },
        {
          key: "score",
          label: "Score"
        },
        {
          key: "possibles",
          label: "Possibles"
        },
        {
          key: "risk_assigned",
          label: "Risk Assigned"
        }
      ],
      FinalProbabilityItems: [
        {
          action: "Alert Probability",
          score: "100.0%",
          possibles: "1.0",
          risk_assigned: "Probable",
          _cellVariants: {
            risk_assigned: "danger"
          }
        }
      ]
    };
  },
  methods: {
    formatDate(value) {
      if (value) {
        return moment(String(value)).format("DD/MM/YYYY");
      }
    },
    formatYear(value) {
      if (value) {
        return moment(String(value)).format("YYYY");
      }
    },
    addFirstName() {
      this.disableFirstName = true;
    },
    addMiddleName() {
      this.disableMiddleName = true;
    },
    addLastName() {
      this.disableLastName = true;
    },
    getAgeFromBirthday(dateOfBirth) {
      if (dateOfBirth) {
        var totalMonths = moment().diff(dateOfBirth, "months");
        var years = parseInt(totalMonths / 12);
        var months = totalMonths % 12;
        if (months !== 0) {
          return parseFloat(years + "." + months);
        }
        return years;
      }
      return null;
    }
  }
};
</script>

<style>
.heanding {
  background-color: blue;
}
.custom-date-picker {
  width: 100%;
  border: none;
}
.custom-date-picker:focus {
  border: none;
}
.date-calender {
  width: 250px !important;
  background: #dee2e6 !important;
}
.table th,
.table td {
  vertical-align: middle;
}
</style>
